module.exports = __webpack_public_path__ + "static/media/14-g7.bf7472a2.jpg";